module.exports = __webpack_public_path__ + "img/88.71773362.svg";